let prefetched = false;

export const prefetchVisitorRoutes = () => {
  if (prefetched || typeof window === "undefined") {
    return;
  }

  prefetched = true;

  const load = () => {
    import(/* webpackPrefetch: true */ "../panel/edit_order/[orderId]");
    import(/* webpackPrefetch: true */ "../panel/payment/[factorId]");
    import(/* webpackPrefetch: true */ "../panel/show_factor/[factorId]");
    import(/* webpackPrefetch: true */ "../panel/orders/NewOrders");
    import(/* webpackPrefetch: true */ "../panel/orders/Ongoing");
    import(/* webpackPrefetch: true */ "../panel/calendar/[shopId]");
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(load, { timeout: 2500 });
  } else {
    window.setTimeout(load, 1500);
  }
};
